import { JOURNAL_URL } from "@op/entities";
import moment from "moment";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

//  Разметка JSON-LD, созданная Мастером разметки структурированных данных Google.
interface IProps {
  data: ArticleDetail;
  author: AuthorResponse;
}

export function Schema({ data, author }: IProps) {
  const router = useRouter();
  const { t } = useTranslation();

  const schema = {
    "@context": "http://schema.org",
    "@type": "Article",
    name: data.article_name,
    author: {
      "@type": "Person",
      name: author.name,
    },
    datePublished: moment(data.date).format("YYYY-MM-DD"),
    image: data.cover_image,
    articleSection: data.tag_name,
    url: `${JOURNAL_URL}/${router.asPath.slice(1)}`,
    publisher: {
      "@type": "Organization",
      name: t("JournalTitle"),
    },
    articleBody: data.content.blocks.reduce((result, chunk) => {
      const text = chunk.data.text;
      return text ? result + text : result;
    }, ""),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
